export const common = {
  nav: {
    home: 'Strona Główna',
    products: 'Produkty',
    electricFireplaces: 'Kominki Elektryczne',
    wallFireplaces: 'Kominki Wolnostojące',
    builtInFireplaces: 'Kominki Wbudowane',
    threeSidedFireplaces: 'Kominki 3-Stronne',
    panoramaFireplaces: 'Kominki Panoramiczne',
    waterVaporFireplaces: 'Kominki Parowe',
    accessories: 'Akcesoria',
    inspiration: 'Inspiracje',
    becomeDealer: 'Zostań Dealerem',
    about: 'O Dutch Fires',
    support: 'Wsparcie',
    contact: 'Kontakt',
    categories: {
      wallFireplaces: 'Kominki Wolnostojące',
      builtIn: 'Kominki Wbudowane',
      threeSided: 'Kominki 3-Stronne',
      panorama: 'Kominki Panoramiczne',
      waterVapor: 'Kominki Parowe',
      accessories: 'Akcesoria'
    }
  },
  hero: {
    badge: 'HURTOWNIA B2B',
    title: 'Premium Kominki Elektryczne',
    titleSecond: 'Dla Profesjonalistów',
    subtitle: 'Dostępne wyłącznie przez naszą oficjalną sieć dealerów europejskich',
    ctaPrimary: 'Zostań Dealerem',
    ctaSecondary: 'Zobacz Produkty',
    stats: {
      dealers: 'Dealerów',
      countries: 'Krajów',
      certified: 'Certyfikat CE'
    }
  },
  usps: {
    europeanBrand: {
      title: 'Marka Europejska',
      description: 'Premium jakość z Europy'
    },
    fastDelivery: {
      title: 'Szybka Dostawa',
      description: 'Niezawodna logistyka w całej Europie'
    },
    highMargins: {
      title: 'Wysokie Marże',
      description: 'Atrakcyjne ceny hurtowe'
    },
    fullSupport: {
      title: 'Pełne Wsparcie',
      description: 'Wsparcie marketingowe i techniczne'
    }
  },
  categories: {
    title: 'Nasze Kategorie Produktów',
    wallFireplaces: 'Kominki Ścienne',
    freestandingFireplaces: 'Kominki Wolnostojące',
    builtIn: 'Kominki Wbudowane',
    threeSided: 'Kominki 3-Stronne',
    panorama: 'Kominki Panoramiczne',
    waterVapor: 'Kominki Parowe',
    accessories: 'Akcesoria',
    models: 'Modeli',
    viewProducts: 'Zobacz produkty',
    showAll: 'Zobacz wszystkie produkty',
    clearFilter: 'Wyczyść filtr'
  },
  whyDutchFire: {
    label: 'DLACZEGO DUTCH FIRES',
    title: 'Twój Partner w Premium Rozwiązaniach Kominkowych',
    subtitle: 'Wspieramy dealerów czymś więcej niż tylko produktami',
    wholesalePrices: {
      title: 'Ceny Hurtowe',
      description: 'Skorzystaj z atrakcyjnych marż i konkurencyjnych cen dla swojego biznesu.',
      benefits: ['Struktura cen wielopoziomowych', 'Dostępne rabaty ilościowe', 'Przejrzyste warunki']
    },
    marketingSupport: {
      title: 'Wsparcie Marketingowe',
      description: 'Kompleksowe materiały marketingowe i wsparcie dla Twoich działań sprzedażowych.',
      benefits: ['Profesjonalne zdjęcia produktów', 'Materiały marketingowe', 'Treści social media']
    },
    technicalTraining: {
      title: 'Szkolenia Techniczne',
      description: 'Regularne szkolenia i wsparcie techniczne dla Ciebie i Twojego zespołu.',
      benefits: ['Szkolenia online', 'Demonstracje produktów', 'Wsparcie techniczne 24/7']
    }
  },
  inspiration: {
    label: 'INSPIRACJE',
    title: 'Dutch Fires w Akcji',
    subtitle: 'Odkryj, jak nasi dealerzy integrują Dutch Fires w swoich projektach',
    viewProject: 'Zobacz projekt',
    viewPossibilities: 'Odkryj możliwości',
    cta: 'Zostań Dealerem – Uzyskaj Dostęp do Wszystkich Projektów',
    viewAll: 'Zobacz Wszystkie Projekty',
    projects: {
      luxuryPenthouse: 'Luksusowy Penthouse',
      hotelLobby: 'Lobby Hotelowe',
      modernOffice: 'Nowoczesne Biuro',
      restaurantAmbiance: 'Atmosfera Restauracji',
      residentialVilla: 'Willa Mieszkalna',
      showroom: 'Showroom'
    }
  },
  inspirationPage: {
    categories: {
      all: 'Wszystkie Projekty',
      residential: 'Mieszkalne',
      hospitality: 'Hotelarstwo',
      commercial: 'Komercyjne'
    },
    cta: {
      title: 'Chcesz Dutch Fires w swoich projektach?',
      description: 'Zostań oficjalnym dealerem i uzyskaj dostęp do ekskluzywnego wsparcia projektowego, materiałów marketingowych i doradztwa technicznego dla swoich instalacji.',
      button: 'Zostań Dealerem Teraz'
    }
  },
  dealerBenefits: {
    title: 'Dołącz do 500+ Odnoszących Sukcesy Dealerów',
    intro: 'Stań się częścią naszej rosnącej sieci profesjonalnych partnerów w całej Europie i korzystaj z ekskluzywnych korzyści.',
    benefit1: {
      title: 'Ekskluzywne Prawa Terytorialne',
      description: 'Zabezpiecz swoje terytorium i zminimalizuj konkurencję w swoim regionie.'
    },
    benefit2: {
      title: 'Kompleksowe Szkolenie Produktowe',
      description: 'Regularne szkolenia dotyczące produktów, instalacji i technik sprzedaży.'
    },
    benefit3: {
      title: 'Wsparcie Marketingowe i Sprzedażowe',
      description: 'Profesjonalne materiały i kampanie wspierające Twój biznes.'
    },
    benefit4: {
      title: 'Wsparcie Techniczne',
      description: 'Bezpośredni dostęp do naszego zespołu ekspertów w przypadku wszystkich pytań technicznych.'
    },
    benefit5: {
      title: 'Elastyczne Opcje Dostawy',
      description: 'Dropshipping, magazyn lub dostawa projektowa – Ty wybierasz.'
    },
    stats: {
      dealers: 'Aktywnych Dealerów',
      countries: 'Krajów',
      satisfaction: 'Zadowolenie'
    },
    cta: 'Rozpocznij Rejestrację'
  },
  dealerProcess: {
    badge: 'PROSTY PROCES',
    title: 'Zostań Oficjalnym Dealerem w 3 Krokach',
    step1: {
      title: 'Rejestracja',
      description: 'Wypełnij formularz online danymi swojej firmy',
      time: '2 Minuty'
    },
    step2: {
      title: 'Weryfikacja',
      description: 'Sprawdzamy Twoje informacje i kontaktujemy się osobiście',
      time: '1-2 Dni'
    },
    step3: {
      title: 'Aktywacja',
      description: 'Uzyskaj dostęp do portalu dealera i zacznij',
      time: 'Natychmiast'
    },
    reassurance: 'Bez zobowiązań • Darmowa rejestracja • Osobisty kontakt',
    cta: 'Wypełnij Formularz Rejestracyjny'
  },
  testimonials: {
    label: 'CO MÓWIĄ DEALERZY',
    title: 'Zaufali Nam Profesjonaliści',
    dealerSince: 'Dealer od'
  },
  productShowcase: {
    title: 'Odkryj Naszą Kolekcję',
    subtitle: 'Wszystkie produkty dostępne przez nasz portal dealerski',
    moreInfo: 'Więcej informacji',
    viewAll: 'Zobacz Wszystkie Produkty',
    productsFound: 'produktów znaleziono',
    noProducts: 'Nie znaleziono produktów w tej kategorii'
  },
  resources: {
    downloads: {
      title: 'Zasoby dla Dealerów',
      catalog: 'Katalog Produktów 2025',
      technicalSpecs: 'Specyfikacje Techniczne',
      installationGuide: 'Instrukcja Instalacji',
      marketingMaterials: 'Materiały Marketingowe'
    },
    support: {
      title: 'Chętnie Pomożemy',
      contactText: 'Skontaktuj się z nami w sprawie wsparcia dealerskiego',
      email: 'Wsparcie Email',
      emailResponse: 'Odpowiedź w ciągu 24h'
    }
  },
  footer: {
    tagline: 'Premium Rozwiązania Kominkowe B2B',
    newsletter: {
      placeholder: 'Twój służbowy adres email',
      disclaimer: 'Tylko dla klientów biznesowych'
    },
    products: 'Produkty',
    information: 'Informacje',
    contact: 'Kontakt',
    copyright: '© 2025 Dutch Fires',
    businessOnly: 'Tylko dla klientów biznesowych',
    legal: {
      imprint: 'Impressum',
      privacy: 'Prywatność',
      terms: 'Warunki',
      cookies: 'Cookies'
    }
  },
  common: {
    learnMore: 'Dowiedz się więcej',
    contactUs: 'Skontaktuj się'
  },
  cookies: {
    title: 'Ustawienia plików cookie',
    description: 'Używamy plików cookie, aby poprawić Twoje doświadczenie i analizować naszą stronę. Możesz dostosować ustawienia w dowolnym momencie.',
    settings: 'Ustawienia',
    necessaryOnly: 'Tylko niezbędne',
    acceptAll: 'Zaakceptuj wszystkie',
    settingsTitle: 'Zarządzaj ustawieniami plików cookie',
    savePreferences: 'Zapisz preferencje',
    alwaysOn: 'Zawsze włączone',
    necessary: {
      title: 'Niezbędne pliki cookie',
      description: 'Te pliki cookie są wymagane do podstawowej funkcjonalności strony i nie można ich wyłączyć.'
    },
    analytics: {
      title: 'Analityczne pliki cookie',
      description: 'Te pliki cookie pomagają nam zrozumieć, jak odwiedzający korzystają z naszej strony.'
    },
    marketing: {
      title: 'Marketingowe pliki cookie',
      description: 'Te pliki cookie służą do personalizacji reklam.'
    }
  },
  productCTA: {
    b2bOnly: 'Tylko B2B',
    dealerOnly: 'Tylko dla dealerów',
    title: 'Zainteresowany tym produktem?',
    titleWithProduct: 'Zainteresowany {{product}}?',
    description: 'Zostań oficjalnym dealerem Dutch Fires i uzyskaj dostęp do cen hurtowych, ekskluzywnych warunków i pełnego wsparcia.',
    interestedInProduct: 'Zainteresowany {{product}}? Zostań dealerem, aby poznać ceny i składać zamówienia.',
    interestedGeneral: 'Zainteresowany naszymi produktami? Zostań dealerem, aby poznać ceny i składać zamówienia.',
    inlineTitle: 'Ceny dostępne tylko dla zarejestrowanych dealerów',
    benefit1: 'Dostęp do cen hurtowych',
    benefit2: 'Ekskluzywne warunki dealerskie',
    benefit3: 'Osobista opieka',
    becomeDealer: 'Zostań dealerem',
    ctaButton: 'Zostań Dealerem Teraz',
    disclaimer: 'Tylko dla firm z ważną rejestracją',
    viewDetails: 'Zobacz szczegóły'
  }
};